import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/student/training-course-list`;

export const trainingCourseListRoutesObj = {
  list: baseRoute,
  view: `${baseRoute}/view/:trainingCourseId`,
} as const;

export type ITrainingCourseListRouteParams = IExtractRouteParamMap<
  typeof trainingCourseListRoutesObj
>;

export const trainingCourseListPath = createPaths<
  typeof trainingCourseListRoutesObj,
  ITrainingCourseListRouteParams
>(trainingCourseListRoutesObj);
